module.exports = __webpack_public_path__ + "static/media/Ace wo Nerae - Box Cover.7c9885a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/box/Ace wo Nerae - Box Cover.jpg
// module id = 85
// module chunks = 0